import "./scss/index.ts";
import { Route, Routes } from "react-router-dom";

import routes from "./pages/index";
import { useEffect, useState } from "react";
import Preloader from "components/preloader/Preloader";
import AOS from "aos";
import { WaitlistModalProvider } from "components/waitlist/WaitlistModal";

function App() {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    AOS.init({
      duration: 2000,
    });
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {!loading ? (
        <WaitlistModalProvider>
          <Routes>
            {routes.map((data, index) => (
              <Route
                exact={true}
                path={data.path}
                element={data.component}
                key={index}
              />
            ))}
            {/* <Route path='*' element={<Page404 />} /> */}
          </Routes>
        </WaitlistModalProvider>
      ) : (
        <Preloader />
      )}
    </>
  );
}

export default App;
